import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account, PositivePayCheckFile } from "model";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";
import TASPositivePayImportChecksUsingTemplatePage, { getDefaultData, getDefaultUI } from "components/pages/TASPositivePayImportChecksUsingTemplatePage";

/**
 * @name CapturePositivePayImportChecksAccountsSelected
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Import Checks - Misc" capture group.
 */
export default function CapturePositivePayImportChecksAccountsSelected(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    const defaultData = getDefaultData();
    defaultData.checkForms = defaultData.checkForms.reduce((acc, item) => {
        item.account = Account.initAllBusinessChecking()[0].id;
        acc.push(item);
        return acc;
    }, []);

    // Switch the order of the last 2 checks in order to match captures.
    const placeholder = defaultData.checkForms[2];
    defaultData.checkForms[2] = defaultData.checkForms[3];
    defaultData.checkForms[3] = placeholder;

    const data = BCMSStateManagerCRUD.init(defaultData)
    .submit();

    return <TASPositivePayImportChecksUsingTemplatePage data={ data } />;
}